import axios from "axios";

import { SET_UNITOFMEASUREMENTS } from "./types";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";

export const getUnitOfMeasurements = createAsyncAction(
  resolve => () =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = await axios.get(`${getApiUrl()}/unitofmeasurement`, { params: { lang } });
      dispatch({ type: SET_UNITOFMEASUREMENTS, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_UNITOFMEASUREMENTS, payload: {} })
);



// WEBPACK FOOTER //
// ./src/actions/unitOfMeasurementAction.js